import { put } from 'redux-saga/effects';
import Swal from 'sweetalert2';

import { loadSuccess, loadFailure, loadRequest } from './actions';

export function* loadDataHoraordemDeCarga({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const response = {
      dtAgendamento: payload.dtAgendamento,
      codHorario: payload.codHorario,
      codPlataforma: payload.codPlataforma,
      dhAgendamento: payload.dhAgendamento,
    };
    yield put(loadSuccess(response));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar data e horários da ordem de carga, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
